interface PlanInfoProps {
  [key: string]: {
    name: string;
    price: number;
    periodPrice: number;
    description: string;
    productId: string;
    duration: string;
    currency?: string; // 'USD' | 'EUR' | 'MXN',
    currencySymbol?: string; // '$' | '€' | 'Mex$',
  };
}

export const PLANS: PlanInfoProps = {
  'fl-monthly-intro1d-99-4999': {
    name: 'fl-monthly-intro1d-99-4999',
    price: 49.99,
    periodPrice: 0.99,
    description: 'monthly',
    productId: '1 month - $49.99',
    duration: '1 day - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro1d-125-4999': {
    name: 'fl-monthly-intro1d-125-4999',
    price: 49.99,
    periodPrice: 1.25,
    description: 'monthly',
    productId: '1 month - $49.99',
    duration: '1 day - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro1d-250-4999': {
    name: 'fl-monthly-intro1d-250-4999',
    price: 49.99,
    periodPrice: 2.5,
    description: 'monthly',
    productId: '1 month - $49.99',
    duration: '1 day - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro7d-699-3999': {
    name: 'fl-monthly-intro7d-699-3999',
    price: 39.99,
    periodPrice: 6.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: 'week - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro7d-1699-4999': {
    name: 'fl-monthly-intro7d-1699-4999',
    price: 49.99,
    periodPrice: 16.99,
    description: 'monthly',
    productId: '1 month - $49.99',
    duration: 'week - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro7d-747-4278': {
    name: 'fl-monthly-intro7d-747-4278',
    price: 42.78,
    periodPrice: 7.47,
    description: 'monthly',
    productId: '1 month - $42.78',
    duration: 'week - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro5d-499-3999': {
    name: 'fl-monthly-intro5d-499-3999',
    price: 39.99,
    periodPrice: 4.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '5 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro5d-999-3999': {
    name: 'fl-monthly-intro5d-999-3999',
    price: 39.99,
    periodPrice: 9.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '5 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro3d-299-3999': {
    name: 'fl-monthly-intro3d-299-3999',
    price: 39.99,
    periodPrice: 2.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro3d-599-3999': {
    name: 'fl-monthly-intro3d-599-3999',
    price: 39.99,
    periodPrice: 5.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-3999': {
    name: 'fl-monthly-3999',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-4278': {
    name: 'fl-monthly-4278',
    price: 42.78,
    periodPrice: 42.78,
    description: 'monthly',
    productId: '1 month - $42.78',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-4999': {
    name: 'fl-monthly-4999',
    price: 49.99,
    periodPrice: 49.99,
    description: 'monthly',
    productId: '1 month - $49.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-5999': {
    name: 'fl-3month-5999',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    productId: '3 months - $59.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-9999-usd-6-month-sub': {
    name: 'fl-9999-usd-6-month-sub',
    price: 99.99,
    periodPrice: 99.99,
    description: 'semi-annually',
    productId: '6 months - $99.99',
    duration: '6 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-6418': {
    name: 'fl-3month-6418',
    price: 64.18,
    periodPrice: 64.18,
    description: 'quarterly',
    productId: '3 months - $64.18',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3999-usd-1-month-intro-699-usd-3-day-sub': {
    name: 'fl-3999-usd-1-month-intro-699-usd-3-day-sub',
    price: 39.99,
    periodPrice: 6.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3999-usd-1-month-intro-149-usd-3-day-sub': {
    name: 'fl-3999-usd-1-month-intro-149-usd-3-day-sub',
    price: 39.99,
    periodPrice: 1.49,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3999-usd-1-month-intro-239-usd-3-day-sub': {
    name: 'fl-3999-usd-1-month-intro-239-usd-3-day-sub',
    price: 39.99,
    periodPrice: 2.39,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3999-usd-1-month-intro-599-usd-7-day-sub': {
    name: 'fl-3999-usd-1-month-intro-599-usd-7-day-sub',
    price: 39.99,
    periodPrice: 5.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '7 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3999-usd-1-month-intro-1499-usd-7-day-sub': {
    name: 'fl-3999-usd-1-month-intro-1499-usd-7-day-sub',
    price: 39.99,
    periodPrice: 14.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '7 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3999-usd-1-month-intro-999-usd-1-month-sub': {
    name: 'fl-3999-usd-1-month-intro-999-usd-1-month-sub',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3999-usd-1-month-intro-1599-usd-1-month-sub': {
    name: 'fl-3999-usd-1-month-intro-1599-usd-1-month-sub',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    productId: '1 month - $39.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-5999-usd-3-month-intro-1499-usd-3-month-sub': {
    name: 'fl-5999-usd-3-month-intro-1499-usd-3-month-sub',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    productId: '3 months - $59.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-5999-usd-3-month-intro-2399-usd-3-month-sub': {
    name: 'fl-5999-usd-3-month-intro-2399-usd-3-month-sub',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    productId: '3 months - $59.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3399-usd-1-month-intro-249-usd-3-day-sub': {
    name: 'fl-3399-usd-1-month-intro-249-usd-3-day-sub',
    price: 33.99,
    periodPrice: 2.49,
    description: 'monthly',
    productId: '1 month - $33.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3399-usd-1-month-intro-499-usd-3-day-sub': {
    name: 'fl-3399-usd-1-month-intro-499-usd-3-day-sub',
    price: 33.99,
    periodPrice: 4.99,
    description: 'monthly',
    productId: '1 month - $33.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3399-usd-1-month-intro-1699-usd-1-month-sub': {
    name: 'fl-3399-usd-1-month-intro-1699-usd-1-month-sub',
    price: 33.99,
    periodPrice: 33.99,
    description: 'monthly',
    productId: '1 month - $33.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-5099-usd-3-month-intro-3399-usd-3-month-sub': {
    name: 'fl-5099-usd-3-month-intro-3399-usd-3-month-sub',
    price: 50.99,
    periodPrice: 50.99,
    description: 'quarterly',
    productId: '3 months - $50.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3099-usd-1-month-intro-229-usd-3-day-sub': {
    name: 'fl-3099-usd-1-month-intro-229-usd-3-day-sub',
    price: 30.99,
    periodPrice: 2.29,
    description: 'monthly',
    productId: '1 month - $30.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3099-usd-1-month-intro-499-usd-3-day-sub': {
    name: 'fl-3099-usd-1-month-intro-499-usd-3-day-sub',
    price: 30.99,
    periodPrice: 4.99,
    description: 'monthly',
    productId: '1 month - $30.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3099-usd-1-month-intro-1549-usd-1-month-sub': {
    name: 'fl-3099-usd-1-month-intro-1549-usd-1-month-sub',
    price: 30.99,
    periodPrice: 30.99,
    description: 'monthly',
    productId: '1 month - $30.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-4599-usd-3-month-intro-3099-usd-3-month-sub': {
    name: 'fl-4599-usd-3-month-intro-3099-usd-3-month-sub',
    price: 45.99,
    periodPrice: 45.99,
    description: 'quarterly',
    productId: '3 months - $45.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },

  // EURO plans
  'fl-monthly-intro1d-99-4999-eur': {
    name: 'fl-monthly-intro1d-99-4999-eur',
    price: 49.99,
    periodPrice: 0.99,
    description: 'monthly',
    productId: '1 month - €49.99',
    duration: '1 day - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro1d-125-4999-eur': {
    name: 'fl-monthly-intro1d-125-4999-eur',
    price: 49.99,
    periodPrice: 1.25,
    description: 'monthly',
    productId: '1 month - €49.99',
    duration: '1 day - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro1d-250-4999-eur': {
    name: 'fl-monthly-intro1d-250-4999-eur',
    price: 49.99,
    periodPrice: 2.5,
    description: 'monthly',
    productId: '1 month - €49.99',
    duration: '1 day - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro7d-699-3999-eur': {
    name: 'fl-monthly-intro7d-699-3999-eur',
    price: 39.99,
    periodPrice: 6.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: 'week - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro7d-1699-4999-eur': {
    name: 'fl-monthly-intro7d-1699-4999-eur',
    price: 49.99,
    periodPrice: 16.99,
    description: 'monthly',
    productId: '1 month - €49.99',
    duration: 'week - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro7d-747-4278-eur': {
    name: 'fl-monthly-intro7d-747-4278-eur',
    price: 42.78,
    periodPrice: 7.47,
    description: 'monthly',
    productId: '1 month - €42.78',
    duration: 'week - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro5d-499-3999-eur': {
    name: 'fl-monthly-intro5d-499-3999-eur',
    price: 39.99,
    periodPrice: 4.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '5 days - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro5d-999-3999-eur': {
    name: 'fl-monthly-intro5d-999-3999-eur',
    price: 39.99,
    periodPrice: 9.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '5 days - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro3d-299-3999-eur': {
    name: 'fl-monthly-intro3d-299-3999-eur',
    price: 39.99,
    periodPrice: 2.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '3 days - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro3d-599-3999-eur': {
    name: 'fl-monthly-intro3d-599-3999-eur',
    price: 39.99,
    periodPrice: 5.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '3 days - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-3999-eur': {
    name: 'fl-monthly-3999-eur',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-4278-eur': {
    name: 'fl-monthly-4278-eur',
    price: 42.78,
    periodPrice: 42.78,
    description: 'monthly',
    productId: '1 month - €42.78',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-4999-eur': {
    name: 'fl-monthly-4999-eur',
    price: 49.99,
    periodPrice: 49.99,
    description: 'monthly',
    productId: '1 month - €49.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-5999-eur': {
    name: 'fl-3month-5999-eur',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    productId: '3 months - €59.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-9999-eur-6-month-sub': {
    name: 'fl-9999-eur-6-month-sub',
    price: 99.99,
    periodPrice: 99.99,
    description: 'semi-annually',
    productId: '6 months - €99.99',
    duration: '6 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-6418-eur': {
    name: 'fl-3month-6418-eur',
    price: 64.18,
    periodPrice: 64.18,
    description: 'quarterly',
    productId: '3 months - €64.18',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3999-eur-1-month-intro-699-eur-3-day-sub': {
    name: 'fl-3999-eur-1-month-intro-699-eur-3-day-sub',
    price: 39.99,
    periodPrice: 6.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3999-eur-1-month-intro-149-eur-3-day-sub': {
    name: 'fl-3999-eur-1-month-intro-149-eur-3-day-sub',
    price: 39.99,
    periodPrice: 1.49,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3999-eur-1-month-intro-239-eur-3-day-sub': {
    name: 'fl-3999-eur-1-month-intro-239-eur-3-day-sub',
    price: 39.99,
    periodPrice: 2.39,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3999-eur-1-month-intro-599-eur-7-day-sub': {
    name: 'fl-3999-eur-1-month-intro-599-eur-7-day-sub',
    price: 39.99,
    periodPrice: 5.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '7 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3999-eur-1-month-intro-1499-eur-7-day-sub': {
    name: 'fl-3999-eur-1-month-intro-1499-eur-7-day-sub',
    price: 39.99,
    periodPrice: 14.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '7 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3999-eur-1-month-intro-999-eur-1-month-sub': {
    name: 'fl-3999-eur-1-month-intro-999-eur-1-month-sub',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3999-eur-1-month-intro-1599-eur-1-month-sub': {
    name: 'fl-3999-eur-1-month-intro-1599-eur-1-month-sub',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    productId: '1 month - €39.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-5999-eur-3-month-intro-1499-eur-3-month-sub': {
    name: 'fl-5999-eur-3-month-intro-1499-eur-3-month-sub',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    productId: '3 months - €59.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-5999-eur-3-month-intro-2399-eur-3-month-sub': {
    name: 'fl-5999-eur-3-month-intro-2399-eur-3-month-sub',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    productId: '3 months - €59.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },

  // Canadian dollar plans
  'fl-monthly-intro3d-399-5899-cad': {
    name: 'fl-monthly-intro3d-399-5899-cad',
    price: 58.99,
    periodPrice: 3.99,
    description: 'monthly',
    productId: '1 month - C$58.99',
    duration: '3 days - month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-intro3d-899-5899-cad': {
    name: 'fl-monthly-intro3d-899-5899-cad',
    price: 58.99,
    periodPrice: 8.99,
    description: 'monthly',
    productId: '1 month - C$58.99',
    duration: '3 days - month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-5899-cad-1-month-intro-299-cad-3-day-sub': {
    name: 'fl-5899-cad-1-month-intro-299-cad-3-day-sub',
    price: 58.99,
    periodPrice: 2.99,
    description: 'monthly',
    productId: '1 month - C$58.99',
    duration: '3 days - month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-5899-cad-1-month-intro-199-cad-3-day-sub': {
    name: 'fl-5899-cad-1-month-intro-199-cad-3-day-sub',
    price: 58.99,
    periodPrice: 1.99,
    description: 'monthly',
    productId: '1 month - C$58.99',
    duration: '3 days - month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-intro5d-499-3999-cad': {
    name: 'fl-monthly-intro5d-499-3999-cad',
    price: 39.99,
    periodPrice: 4.99,
    description: 'monthly',
    productId: '1 month - C$39.99',
    duration: '5 days - month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-3999-cad': {
    name: 'fl-monthly-3999-cad',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    productId: '1 month - C$39.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-5899-cad': {
    name: 'fl-monthly-5899-cad',
    price: 58.99,
    periodPrice: 58.99,
    description: 'monthly',
    productId: '1 month - C$58.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-3month-5999-cad': {
    name: 'fl-3month-5999-cad',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    productId: '3 months - C$59.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-3month-8899-cad': {
    name: 'fl-3month-8899-cad',
    price: 88.99,
    periodPrice: 88.99,
    description: 'quarterly',
    productId: '3 months - C$88.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },

  // Australian dollar plans
  'fl-monthly-intro3d-399-5199-aud': {
    name: 'fl-monthly-intro3d-399-5199-aud',
    price: 51.99,
    periodPrice: 3.99,
    description: 'monthly',
    productId: '1 month - A$51.99',
    duration: '3 days - month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-monthly-intro3d-799-5199-aud': {
    name: 'fl-monthly-intro3d-799-5199-aud',
    price: 51.99,
    periodPrice: 7.99,
    description: 'monthly',
    productId: '1 month - A$51.99',
    duration: '3 days - month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-5199-aud-1-month-intro-299-aud-3-day-sub': {
    name: 'fl-5199-aud-1-month-intro-299-aud-3-day-sub',
    price: 51.99,
    periodPrice: 2.99,
    description: 'monthly',
    productId: '1 month - A$51.99',
    duration: '3 days - month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-5199-aud-1-month-intro-199-aud-3-day-sub': {
    name: 'fl-5199-aud-1-month-intro-199-aud-3-day-sub',
    price: 51.99,
    periodPrice: 1.99,
    description: 'monthly',
    productId: '1 month - A$51.99',
    duration: '3 days - month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-monthly-intro5d-499-3999-aud': {
    name: 'fl-monthly-intro5d-499-3999-aud',
    price: 39.99,
    periodPrice: 4.99,
    description: 'monthly',
    productId: '1 month - A$39.99',
    duration: '5 days - month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-monthly-3999-aud': {
    name: 'fl-monthly-3999-aud',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    productId: '1 month - A$39.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-monthly-5199-aud': {
    name: 'fl-monthly-5199-aud',
    price: 51.99,
    periodPrice: 51.99,
    description: 'monthly',
    productId: '1 month - A$51.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-3month-5999-aud': {
    name: 'fl-3month-5999-aud',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    productId: '3 months - A$59.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-3month-7799-aud': {
    name: 'fl-3month-7799-aud',
    price: 77.99,
    periodPrice: 77.99,
    description: 'quarterly',
    productId: '3 months - A$77.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },

  // Brasilian Real plans
  'fl-monthly-intro3d-1499-19999-brl': {
    name: 'fl-monthly-intro3d-1499-19999-brl',
    price: 199.99,
    periodPrice: 14.99,
    description: 'monthly',
    productId: '1 month - R$199.99',
    duration: '3 days - month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-monthly-intro3d-2899-19999-brl': {
    name: 'fl-monthly-intro3d-2899-19999-brl',
    price: 199.99,
    periodPrice: 28.99,
    description: 'monthly',
    productId: '1 month - R$199.99',
    duration: '3 days - month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-monthly-intro5d-1995-15441-brl': {
    name: 'fl-monthly-intro5d-1995-15441-brl',
    price: 154.41,
    periodPrice: 19.95,
    description: 'monthly',
    productId: '1 month - R$154.41',
    duration: '5 days - month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-monthly-15441-brl': {
    name: 'fl-monthly-15441-brl',
    price: 154.41,
    periodPrice: 154.41,
    description: 'monthly',
    productId: '1 month - R$154.41',
    duration: '1 month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-monthly-19999-brl': {
    name: 'fl-monthly-19999-brl',
    price: 199.99,
    periodPrice: 199.99,
    description: 'monthly',
    productId: '1 month - R$199.99',
    duration: '1 month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-3month-23163-brl': {
    name: 'fl-3month-23163-brl',
    price: 231.63,
    periodPrice: 231.63,
    description: 'quarterly',
    productId: '3 months - R$231.63',
    duration: '3 months',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-3month-28999-brl': {
    name: 'fl-3month-28999-brl',
    price: 289.99,
    periodPrice: 289.99,
    description: 'quarterly',
    productId: '3 months - R$289.99',
    duration: '3 months',
    currency: 'BRL',
    currencySymbol: 'R$',
  },

  // Mexican Peso plans
  'fl-monthly-intro3d-3499-46999-mxn': {
    name: 'fl-monthly-intro3d-3499-46999-mxn',
    price: 469.99,
    periodPrice: 34.99,
    description: 'monthly',
    productId: '1 month - M$469.99',
    duration: '3 days - month',
    currency: 'MXN',
    currencySymbol: 'M$',
  },
  'fl-monthly-intro3d-7099-46999-mxn': {
    name: 'fl-monthly-intro3d-7099-46999-mxn',
    price: 469.99,
    periodPrice: 70.99,
    description: 'monthly',
    productId: '1 month - M$469.99',
    duration: '3 days - month',
    currency: 'MXN',
    currencySymbol: 'M$',
  },
  'fl-monthly-intro5d-7495-62337-mxn': {
    name: 'fl-monthly-intro5d-7495-62337-mxn',
    price: 623.37,
    periodPrice: 74.95,
    description: 'monthly',
    productId: '1 month - M$623.37',
    duration: '5 days - month',
    currency: 'MXN',
    currencySymbol: 'M$',
  },
  'fl-monthly-46999-mxn': {
    name: 'fl-monthly-46999-mxn',
    price: 469.99,
    periodPrice: 469.99,
    description: 'monthly',
    productId: '1 month - M$469.99',
    duration: '1 month',
    currency: 'MXN',
    currencySymbol: 'M$',
  },
  'fl-monthly-62337-mxn': {
    name: 'fl-monthly-62337-mxn',
    price: 623.37,
    periodPrice: 623.37,
    description: 'monthly',
    productId: '1 month - M$623.37',
    duration: '1 month',
    currency: 'MXN',
    currencySymbol: 'M$',
  },
  'fl-3month-70999-mxn': {
    name: 'fl-3month-70999-mxn',
    price: 709.99,
    periodPrice: 709.99,
    description: 'quarterly',
    productId: '3 months - M$709.99',
    duration: '3 months',
    currency: 'MXN',
    currencySymbol: 'M$',
  },
  'fl-3month-93514-mxn': {
    name: 'fl-3month-93514-mxn',
    price: 935.14,
    periodPrice: 935.14,
    description: 'quarterly',
    productId: '3 months - M$935.14',
    duration: '3 months',
    currency: 'MXN',
    currencySymbol: 'M$',
  },

  // Argentine Peso plans
  'fl-monthly-intro3d-320500-4287100-ars': {
    name: 'fl-monthly-intro3d-320500-4287100-ars',
    price: 42871,
    periodPrice: 3205,
    description: 'monthly',
    productId: '1 month - AR$42871',
    duration: '3 days - month',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-monthly-intro3d-642100-4287100-ars': {
    name: 'fl-monthly-intro3d-642100-4287100-ars',
    price: 42871,
    periodPrice: 6421,
    description: 'monthly',
    productId: '1 month - AR$42871',
    duration: '3 days - month',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-monthly-intro5d-699500-5520500-ars': {
    name: 'fl-monthly-intro5d-699500-5520500-ars',
    price: 55205,
    periodPrice: 6995,
    description: 'monthly',
    productId: '1 month - AR$55205',
    duration: '5 days - month',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-monthly-4287100-ars': {
    name: 'fl-monthly-4287100-ars',
    price: 42871,
    periodPrice: 42871,
    description: 'monthly',
    productId: '1 month - AR$42871',
    duration: '1 month',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-monthly-5520500-ars': {
    name: 'fl-monthly-5520500-ars',
    price: 55205,
    periodPrice: 55205,
    description: 'monthly',
    productId: '1 month - AR$55205',
    duration: '1 month',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-3month-6431200-ars': {
    name: 'fl-3month-6431200-ars',
    price: 64312,
    periodPrice: 64312,
    description: 'quarterly',
    productId: '3 months - AR$64312',
    duration: '3 months',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-3month-8281400-ars': {
    name: 'fl-3month-8281400-ars',
    price: 82814,
    periodPrice: 82814,
    description: 'quarterly',
    productId: '3 months - AR$82814',
    duration: '3 months',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },

  // upsell plans
  'fl-monthly-upsell-999': {
    name: 'fl-monthly-upsell-999',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    productId: '1 month - upsell $9.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-upsell-799': {
    name: 'fl-monthly-upsell-799',
    price: 7.99,
    periodPrice: 7.99,
    description: 'monthly upsell',
    productId: '1 month - upsell $7.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-upsell-599': {
    name: 'fl-monthly-upsell-599',
    price: 5.99,
    periodPrice: 5.99,
    description: 'monthly upsell',
    productId: '1 month - upsell $5.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-upsell-1399': {
    name: 'fl-monthly-upsell-1399',
    price: 13.99,
    periodPrice: 13.99,
    description: 'monthly upsell',
    productId: '1 month - upsell $13.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-upsell-999': {
    name: 'fl-3month-upsell-999',
    price: 9.99,
    periodPrice: 9.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell $9.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-upsell-799': {
    name: 'fl-3month-upsell-799',
    price: 7.99,
    periodPrice: 7.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell $7.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-upsell-599': {
    name: 'fl-3month-upsell-599',
    price: 5.99,
    periodPrice: 5.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell $5.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-upsell-1399': {
    name: 'fl-3month-upsell-1399',
    price: 13.99,
    periodPrice: 13.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell $13.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },

  'fl-monthly-upsell-999-eur': {
    name: 'fl-monthly-upsell-999-eur',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    productId: '1 month - upsell €9.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-upsell-799-eur': {
    name: 'fl-monthly-upsell-799-eur',
    price: 7.99,
    periodPrice: 7.99,
    description: 'monthly upsell',
    productId: '1 month - upsell €7.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-upsell-599-eur': {
    name: 'fl-monthly-upsell-599-eur',
    price: 5.99,
    periodPrice: 5.99,
    description: 'monthly upsell',
    productId: '1 month - upsell €5.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-upsell-1399-eur': {
    name: 'fl-monthly-upsell-1399-eur',
    price: 13.99,
    periodPrice: 13.99,
    description: 'monthly upsell',
    productId: '1 month - upsell €13.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-999-eur': {
    name: 'fl-3month-upsell-999-eur',
    price: 9.99,
    periodPrice: 9.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell €9.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-799-eur': {
    name: 'fl-3month-upsell-799-eur',
    price: 7.99,
    periodPrice: 7.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell €7.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-599-eur': {
    name: 'fl-3month-upsell-599-eur',
    price: 5.99,
    periodPrice: 5.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell €5.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-1399-eur': {
    name: 'fl-3month-upsell-1399-eur',
    price: 13.99,
    periodPrice: 13.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell €13.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },

  // Canadian dollar monthly upsell plans
  'fl-monthly-upsell-599-cad': {
    name: 'fl-monthly-upsell-599-cad',
    price: 5.99,
    periodPrice: 5.99,
    description: 'monthly upsell',
    productId: '1 month - upsell C$5.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-upsell-799-cad': {
    name: 'fl-monthly-upsell-799-cad',
    price: 7.99,
    periodPrice: 7.99,
    description: 'monthly upsell',
    productId: '1 month - upsell C$7.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-upsell-899-cad': {
    name: 'fl-monthly-upsell-899-cad',
    price: 8.99,
    periodPrice: 8.99,
    description: 'monthly upsell',
    productId: '1 month - upsell C$8.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-upsell-999-cad': {
    name: 'fl-monthly-upsell-999-cad',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    productId: '1 month - upsell C$9.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-upsell-1199-cad': {
    name: 'fl-monthly-upsell-1199-cad',
    price: 11.99,
    periodPrice: 11.99,
    description: 'monthly upsell',
    productId: '1 month - upsell C$11.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-upsell-1399-cad': {
    name: 'fl-monthly-upsell-1399-cad',
    price: 13.99,
    periodPrice: 13.99,
    description: 'monthly upsell',
    productId: '1 month - upsell C$13.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-upsell-1499-cad': {
    name: 'fl-monthly-upsell-1499-cad',
    price: 14.99,
    periodPrice: 14.99,
    description: 'monthly upsell',
    productId: '1 month - upsell C$14.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-monthly-upsell-2099-cad': {
    name: 'fl-monthly-upsell-2099-cad',
    price: 20.99,
    periodPrice: 20.99,
    description: 'monthly upsell',
    productId: '1 month - upsell C$20.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  // Canadian dollar quarterly upsell plans
  'fl-3month-upsell-599-cad': {
    name: 'fl-3month-upsell-599-cad',
    price: 5.99,
    periodPrice: 5.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell C$5.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-3month-upsell-799-cad': {
    name: 'fl-3month-upsell-799-cad',
    price: 7.99,
    periodPrice: 7.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell C$7.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-3month-upsell-899-cad': {
    name: 'fl-3month-upsell-899-cad',
    price: 8.99,
    periodPrice: 8.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell C$8.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-3month-upsell-999-cad': {
    name: 'fl-3month-upsell-999-cad',
    price: 9.99,
    periodPrice: 9.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell C$9.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-3month-upsell-1199-cad': {
    name: 'fl-3month-upsell-1199-cad',
    price: 11.99,
    periodPrice: 11.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell C$11.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-3month-upsell-1399-cad': {
    name: 'fl-3month-upsell-1399-cad',
    price: 13.99,
    periodPrice: 13.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell C$13.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-3month-upsell-1499-cad': {
    name: 'fl-3month-upsell-1499-cad',
    price: 14.99,
    periodPrice: 14.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell C$14.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-3month-upsell-2099-cad': {
    name: 'fl-3month-upsell-2099-cad',
    price: 20.99,
    periodPrice: 20.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell C$20.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  // Canadian dollar one-time guide upsell plans
  'fl-onetime-upsell-guide-1299-cad': {
    name: 'fl-onetime-upsell-guide-1299-cad',
    price: 12.99,
    periodPrice: 12.99,
    description: 'one-time',
    productId: 'one-time payment - C$12.99',
    duration: 'one-time',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fl-onetime-upsell-guide-2599-cad': {
    name: 'fl-onetime-upsell-guide-2599-cad',
    price: 25.99,
    periodPrice: 25.99,
    description: 'one-time',
    productId: 'one-time payment - C$25.99',
    duration: 'one-time',
    currency: 'CAD',
    currencySymbol: 'C$',
  },

  // Australian dollar monthly upsell plans
  'fl-monthly-upsell-599-aud': {
    name: 'fl-monthly-upsell-599-aud',
    price: 5.99,
    periodPrice: 5.99,
    description: 'monthly upsell',
    productId: '1 month - upsell A$5.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-monthly-upsell-799-aud': {
    name: 'fl-monthly-upsell-799-aud',
    price: 7.99,
    periodPrice: 7.99,
    description: 'monthly upsell',
    productId: '1 month - upsell A$7.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-monthly-upsell-999-aud': {
    name: 'fl-monthly-upsell-999-aud',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    productId: '1 month - upsell A$9.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-monthly-upsell-1299-aud': {
    name: 'fl-monthly-upsell-1299-aud',
    price: 12.99,
    periodPrice: 12.99,
    description: 'monthly upsell',
    productId: '1 month - upsell A$12.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-monthly-upsell-1399-aud': {
    name: 'fl-monthly-upsell-1399-aud',
    price: 13.99,
    periodPrice: 13.99,
    description: 'monthly upsell',
    productId: '1 month - upsell A$13.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-monthly-upsell-1799-aud': {
    name: 'fl-monthly-upsell-1799-aud',
    price: 17.99,
    periodPrice: 17.99,
    description: 'monthly upsell',
    productId: '1 month - upsell A$17.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },

  // Australian dollar quarterly upsell plans
  'fl-3month-upsell-599-aud': {
    name: 'fl-3month-upsell-599-aud',
    price: 5.99,
    periodPrice: 5.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell A$5.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-3month-upsell-799-aud': {
    name: 'fl-3month-upsell-799-aud',
    price: 7.99,
    periodPrice: 7.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell A$7.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-3month-upsell-999-aud': {
    name: 'fl-3month-upsell-999-aud',
    price: 9.99,
    periodPrice: 9.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell A$9.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-3month-upsell-1299-aud': {
    name: 'fl-3month-upsell-1299-aud',
    price: 12.99,
    periodPrice: 12.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell A$12.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-3month-upsell-1399-aud': {
    name: 'fl-3month-upsell-1399-aud',
    price: 13.99,
    periodPrice: 13.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell A$13.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-3month-upsell-1799-aud': {
    name: 'fl-3month-upsell-1799-aud',
    price: 17.99,
    periodPrice: 17.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell A$17.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },

  // Australian dollar one-time guide upsell plans
  'fl-onetime-upsell-guide-1199-aud': {
    name: 'fl-onetime-upsell-guide-1199-aud',
    price: 11.99,
    periodPrice: 11.99,
    description: 'one-time',
    productId: 'one-time payment - A$11.99',
    duration: 'one-time',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fl-onetime-upsell-guide-2299-aud': {
    name: 'fl-onetime-upsell-guide-2299-aud',
    price: 22.99,
    periodPrice: 22.99,
    description: 'one-time',
    productId: 'one-time payment - A$22.99',
    duration: 'one-time',
    currency: 'AUD',
    currencySymbol: 'A$',
  },

  // Argentine Peso monthly upsell plans
  'fl-monthly-upsell-3049-ars': {
    name: 'fl-monthly-upsell-3049-ars',
    price: 3049,
    periodPrice: 3049,
    description: 'monthly upsell',
    productId: '1 month - upsell AR$3049',
    duration: '1 month',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-monthly-upsell-4062-ars': {
    name: 'fl-monthly-upsell-4062-ars',
    price: 4062,
    periodPrice: 4062,
    description: 'monthly upsell',
    productId: '1 month - upsell AR$4062',
    duration: '1 month',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-monthly-upsell-5086-ars': {
    name: 'fl-monthly-upsell-5086-ars',
    price: 5086,
    periodPrice: 5086,
    description: 'monthly upsell',
    productId: '1 month - upsell AR$5086',
    duration: '1 month',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-monthly-upsell-7122-ars': {
    name: 'fl-monthly-upsell-7122-ars',
    price: 7122,
    periodPrice: 7122,
    description: 'monthly upsell',
    productId: '1 month - upsell AR$7122',
    duration: '1 month',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },

  // Argentine Peso quarterly upsell plans
  'fl-3month-upsell-3049-ars': {
    name: 'fl-3month-upsell-3049-ars',
    price: 3049,
    periodPrice: 3049,
    description: 'quarterly upsell',
    productId: '3 months - upsell AR$3049',
    duration: '3 months',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-3month-upsell-4062-ars': {
    name: 'fl-3month-upsell-4062-ars',
    price: 4062,
    periodPrice: 4062,
    description: 'quarterly upsell',
    productId: '3 months - upsell AR$4062',
    duration: '3 months',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-3month-upsell-5086-ars': {
    name: 'fl-3month-upsell-5086-ars',
    price: 5086,
    periodPrice: 5086,
    description: 'quarterly upsell',
    productId: '3 months - upsell AR$5086',
    duration: '3 months',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-3month-upsell-7122-ars': {
    name: 'fl-3month-upsell-7122-ars',
    price: 7122,
    periodPrice: 7122,
    description: 'quarterly upsell',
    productId: '3 months - upsell AR$7122',
    duration: '3 months',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },

  // Argentine Peso one-time guide upsell plans
  'fl-onetime-upsell-guide-4577-ars': {
    name: 'fl-onetime-upsell-guide-4577-ars',
    price: 4577,
    periodPrice: 4577,
    description: 'one-time',
    productId: 'one-time payment - AR$4577',
    duration: 'one-time',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },
  'fl-onetime-upsell-guide-9159-ars': {
    name: 'fl-onetime-upsell-guide-9159-ars',
    price: 9159,
    periodPrice: 9159,
    description: 'one-time',
    productId: 'one-time payment - AR$9159',
    duration: 'one-time',
    currency: 'ARS',
    currencySymbol: 'AR$',
  },

  // Colombian Peso monthly upsell plans
  'fl-monthly-upsell-1400000-cop': {
    name: 'fl-monthly-upsell-1400000-cop',
    price: 14000,
    periodPrice: 14000,
    description: 'monthly upsell',
    productId: '1 month - upsell COP14000',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-monthly-upsell-1900000-cop': {
    name: 'fl-monthly-upsell-1900000-cop',
    price: 19000,
    periodPrice: 19000,
    description: 'monthly upsell',
    productId: '1 month - upsell COP19000',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-monthly-upsell-2400000-cop': {
    name: 'fl-monthly-upsell-2400000-cop',
    price: 24000,
    periodPrice: 24000,
    description: 'monthly upsell',
    productId: '1 month - upsell COP24000',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-monthly-upsell-3400000-cop': {
    name: 'fl-monthly-upsell-3400000-cop',
    price: 34000,
    periodPrice: 34000,
    description: 'monthly upsell',
    productId: '1 month - upsell COP34000',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },

  // Colombian Peso quarterly upsell plans
  'fl-3month-upsell-1400000-cop': {
    name: 'fl-3month-upsell-1400000-cop',
    price: 14000,
    periodPrice: 14000,
    description: 'quarterly upsell',
    productId: '3 months - upsell COP14000',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-3month-upsell-1900000-cop': {
    name: 'fl-3month-upsell-1900000-cop',
    price: 19000,
    periodPrice: 19000,
    description: 'quarterly upsell',
    productId: '3 months - upsell COP19000',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-3month-upsell-2400000-cop': {
    name: 'fl-3month-upsell-2400000-cop',
    price: 24000,
    periodPrice: 24000,
    description: 'quarterly upsell',
    productId: '3 months - upsell COP24000',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-3month-upsell-3400000-cop': {
    name: 'fl-3month-upsell-3400000-cop',
    price: 34000,
    periodPrice: 34000,
    description: 'quarterly upsell',
    productId: '3 months - upsell COP34000',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },

  // Colombian Peso one-time guide upsell plans
  'fl-onetime-upsell-guide-2200000-cop': {
    name: 'fl-onetime-upsell-guide-2200000-cop',
    price: 22000,
    periodPrice: 22000,
    description: 'one-time',
    productId: 'one-time payment - COP22000',
    duration: 'one-time',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-onetime-upsell-guide-4300000-cop': {
    name: 'fl-onetime-upsell-guide-4300000-cop',
    price: 43000,
    periodPrice: 43000,
    description: 'one-time',
    productId: 'one-time payment - COP43000',
    duration: 'one-time',
    currency: 'COP',
    currencySymbol: 'COP',
  },

  // South African Rand monthly upsell plans
  'fl-11999-zar-1-month-upsell': {
    name: 'fl-11999-zar-1-month-upsell',
    price: 119.99,
    periodPrice: 119.99,
    description: 'monthly upsell',
    productId: '1 month - upsell R119.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-8299-zar-1-month-upsell': {
    name: 'fl-8299-zar-1-month-upsell',
    price: 82.99,
    periodPrice: 82.99,
    description: 'monthly upsell',
    productId: '1 month - upsell R82.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-6599-zar-1-month-upsell': {
    name: 'fl-6599-zar-1-month-upsell',
    price: 65.99,
    periodPrice: 65.99,
    description: 'monthly upsell',
    productId: '1 month - upsell R65.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-4999-zar-1-month-upsell': {
    name: 'fl-4999-zar-1-month-upsell',
    price: 49.99,
    periodPrice: 49.99,
    description: 'monthly upsell',
    productId: '1 month - upsell R49.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },

  // South African Rand quarterly upsell plans
  'fl-11999-zar-3-month-upsell': {
    name: 'fl-11999-zar-3-month-upsell',
    price: 119.99,
    periodPrice: 119.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell R119.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-8299-zar-3-month-upsell': {
    name: 'fl-8299-zar-3-month-upsell',
    price: 82.99,
    periodPrice: 82.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell R82.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-6599-zar-3-month-upsell': {
    name: 'fl-6599-zar-3-month-upsell',
    price: 65.99,
    periodPrice: 65.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell R65.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-4999-zar-3-month-upsell': {
    name: 'fl-4999-zar-3-month-upsell',
    price: 49.99,
    periodPrice: 49.99,
    description: 'quarterly upsell',
    productId: '3 months - upsell R49.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },

  // South African Rand one-time guide upsell plans
  'fl-onetime-upsell-guide-7399-zar': {
    name: 'fl-onetime-upsell-guide-7399-zar',
    price: 73.99,
    periodPrice: 73.99,
    description: 'one-time',
    productId: 'one-time payment - R73.99',
    duration: 'one-time',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-onetime-upsell-guide-14999-zar': {
    name: 'fl-onetime-upsell-guide-14999-zar',
    price: 149.99,
    periodPrice: 149.99,
    description: 'one-time',
    productId: 'one-time payment - R149.99',
    duration: 'one-time',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  // USD one-time guide upsell plans
  'fl-onetime-upsell-guide-899': {
    name: 'fl-onetime-upsell-guide-899',
    price: 8.99,
    periodPrice: 8.99,
    description: 'one-time',
    productId: 'one-time payment - $8.99',
    duration: 'one-time',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-onetime-upsell-guide-1799': {
    name: 'fl-onetime-upsell-guide-1799',
    price: 17.99,
    periodPrice: 17.99,
    description: 'one-time',
    productId: 'one-time payment - $17.99',
    duration: 'one-time',
    currency: 'USD',
    currencySymbol: '$',
  },

  // EUR one-time guide upsell plans
  'fl-onetime-upsell-guide-899-eur': {
    name: 'fl-onetime-upsell-guide-899-eur',
    price: 8.99,
    periodPrice: 8.99,
    description: 'one-time',
    productId: 'one-time payment - €8.99',
    duration: 'one-time',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-onetime-upsell-guide-1799-eur': {
    name: 'fl-onetime-upsell-guide-1799-eur',
    price: 17.99,
    periodPrice: 17.99,
    description: 'one-time',
    productId: 'one-time payment - €17.99',
    duration: 'one-time',
    currency: 'EUR',
    currencySymbol: '€',
  },

  // ???
  'fl-6month-upsell-1399': {
    name: 'fl-6month-upsell-1399',
    price: 13.99,
    periodPrice: 13.99,
    description: 'semi-annual upsell',
    productId: '6 months - upsell $13.99',
    duration: '6 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-6month-upsell-1399-eur': {
    name: 'fl-6month-upsell-1399-eur',
    price: 13.99,
    periodPrice: 13.99,
    description: 'semi-annual upsell',
    productId: '6 months - upsell €13.99',
    duration: '6 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro3d-299-3699': {
    name: 'fl-monthly-intro3d-299-3699',
    price: 36.99,
    periodPrice: 2.99,
    description: 'monthly',
    productId: '1 month - $36.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro3d-799-4999': {
    name: 'fl-monthly-intro3d-799-4999',
    price: 49.99,
    periodPrice: 7.99,
    description: 'monthly',
    productId: '1 month - $49.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro3d-299-3699-eur': {
    name: 'fl-monthly-intro3d-299-3699-eur',
    price: 36.99,
    periodPrice: 2.99,
    description: 'monthly',
    productId: '1 month - €36.99',
    duration: '3 days - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro3d-799-4999-eur': {
    name: 'fl-monthly-intro3d-799-4999-eur',
    price: 49.99,
    periodPrice: 7.99,
    description: 'monthly',
    productId: '1 month - €49.99',
    duration: '3 days - month',
    currency: 'EUR',
    currencySymbol: '€',
  },

  // Testing plans
  'fl-monthly-intro7d-111-211': {
    name: 'fl-monthly-intro7d-111-211',
    price: 2.11,
    periodPrice: 1.11,
    description: 'monthly',
    productId: '1 month - $2.11',
    duration: 'week - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro7d-111-211-eur': {
    name: 'fl-monthly-intro7d-111-211-eur',
    price: 2.11,
    periodPrice: 1.11,
    description: 'monthly',
    productId: '1 month - €2.11',
    duration: 'week - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-212': {
    name: 'fl-monthly-212',
    price: 2.12,
    periodPrice: 2.12,
    description: 'monthly',
    productId: '1 month - $2.12',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-212-eur': {
    name: 'fl-monthly-212-eur',
    price: 2.12,
    periodPrice: 2.12,
    description: 'monthly',
    productId: '1 month - €2.12',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-313': {
    name: 'fl-3month-313',
    price: 3.13,
    periodPrice: 3.13,
    description: 'quarterly',
    productId: '3 months - $3.13',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-313-eur': {
    name: 'fl-3month-313-eur',
    price: 3.13,
    periodPrice: 3.13,
    description: 'quarterly',
    productId: '3 months - €3.13',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-upsell-111': {
    name: 'fl-monthly-upsell-111',
    price: 1.11,
    periodPrice: 1.11,
    description: 'monthly upsell',
    productId: '1 month - upsell $1.11',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-upsell-111-eur': {
    name: 'fl-monthly-upsell-111-eur',
    price: 1.11,
    periodPrice: 1.11,
    description: 'monthly upsell',
    productId: '1 month - upsell €1.11',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-upsell-112': {
    name: 'fl-monthly-upsell-112',
    price: 1.12,
    periodPrice: 1.12,
    description: 'monthly upsell',
    productId: '1 month - upsell $1.12',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-upsell-112-eur': {
    name: 'fl-monthly-upsell-112-eur',
    price: 1.12,
    periodPrice: 1.12,
    description: 'monthly upsell',
    productId: '1 month - upsell €1.12',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-upsell-113': {
    name: 'fl-monthly-upsell-113',
    price: 1.13,
    periodPrice: 1.13,
    description: 'monthly upsell',
    productId: '1 month - upsell $1.13',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-upsell-113-eur': {
    name: 'fl-monthly-upsell-113-eur',
    price: 1.13,
    periodPrice: 1.13,
    description: 'monthly upsell',
    productId: '1 month - upsell €1.13',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-111': {
    name: 'fl-3month-upsell-111',
    price: 1.11,
    periodPrice: 1.11,
    description: 'quarterly upsell',
    productId: '3 months - upsell $1.11',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-upsell-111-eur': {
    name: 'fl-3month-upsell-111-eur',
    price: 1.11,
    periodPrice: 1.11,
    description: 'quarterly upsell',
    productId: '3 months - upsell €1.11',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-112': {
    name: 'fl-3month-upsell-112',
    price: 1.12,
    periodPrice: 1.12,
    description: 'quarterly upsell',
    productId: '3 months - upsell $1.12',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-upsell-112-eur': {
    name: 'fl-3month-upsell-112-eur',
    price: 1.12,
    periodPrice: 1.12,
    description: 'quarterly upsell',
    productId: '3 months - upsell €1.12',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-113': {
    name: 'fl-3month-upsell-113',
    price: 1.13,
    periodPrice: 1.13,
    description: 'quarterly upsell',
    productId: '3 months - upsell $1.13',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-upsell-113-eur': {
    name: 'fl-3month-upsell-113-eur',
    price: 1.13,
    periodPrice: 1.13,
    description: 'quarterly upsell',
    productId: '3 months - upsell €1.13',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-onetime-upsell-test-114': {
    name: 'fl-onetime-upsell-test-114',
    price: 1.14,
    periodPrice: 1.14,
    description: 'one-time',
    productId: 'one-time payment - $1.14',
    duration: 'one-time',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-onetime-upsell-test-114-eur': {
    name: 'fl-onetime-upsell-test-114-eur',
    price: 1.14,
    periodPrice: 1.14,
    description: 'one-time',
    productId: 'one-time payment - €1.14',
    duration: 'one-time',
    currency: 'EUR',
    currencySymbol: '€',
  },

  // Panama USD
  'fl-monthly-intro3d-199-2999': {
    name: 'fl-monthly-intro3d-199-2999',
    price: 29.99,
    periodPrice: 1.99,
    description: 'monthly',
    productId: '1 month - $29.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro3d-399-2999': {
    name: 'fl-monthly-intro3d-399-2999',
    price: 29.99,
    periodPrice: 3.99,
    description: 'monthly',
    productId: '1 month - $29.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-2999-usd-1-month-intro-159-usd-3-day-sub': {
    name: 'fl-2999-usd-1-month-intro-159-usd-3-day-sub',
    price: 29.99,
    periodPrice: 1.59,
    description: 'monthly',
    productId: '1 month - $29.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-2999-usd-1-month-intro-99-usd-3-day-sub': {
    name: 'fl-2999-usd-1-month-intro-99-usd-3-day-sub',
    price: 29.99,
    periodPrice: 0.99,
    description: 'monthly',
    productId: '1 month - $29.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-2999': {
    name: 'fl-monthly-2999',
    price: 29.99,
    periodPrice: 29.99,
    description: 'monthly',
    productId: '1 month - $29.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-4499': {
    name: 'fl-3month-4499',
    price: 44.99,
    periodPrice: 44.99,
    description: 'quarterly',
    productId: '3 months - $44.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },

  // Colombia COP
  'fl-monthly-intro3d-990000-13990000-cop': {
    name: 'fl-monthly-intro3d-990000-13990000-cop',
    price: 139900,
    periodPrice: 9900,
    description: 'monthly',
    productId: '1 month - COP139900',
    duration: '3 days - month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-monthly-intro3d-1980000-13990000-cop': {
    name: 'fl-monthly-intro3d-1980000-13990000-cop',
    price: 139900,
    periodPrice: 19800,
    description: 'monthly',
    productId: '1 month - COP139900',
    duration: '3 days - month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-13990000-cop-1-month-intro-792000-cop-3-day-sub': {
    name: 'fl-13990000-cop-1-month-intro-792000-cop-3-day-sub',
    price: 139900,
    periodPrice: 7920,
    description: 'monthly',
    productId: '1 month - COP139900',
    duration: '3 days - month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-13990000-cop-1-month-intro-495000-cop-3-day-sub': {
    name: 'fl-13990000-cop-1-month-intro-495000-cop-3-day-sub',
    price: 139900,
    periodPrice: 4950,
    description: 'monthly',
    productId: '1 month - COP139900',
    duration: '3 days - month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-monthly-13990000-cop': {
    name: 'fl-monthly-13990000-cop',
    price: 139900,
    periodPrice: 139900,
    description: 'monthly',
    productId: '1 month - COP139900',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fl-3month-20990000-cop': {
    name: 'fl-3month-20990000-cop',
    price: 209900,
    periodPrice: 209900,
    description: 'quarterly',
    productId: '3 months - COP209900',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },

  // Guatemala GTQ
  'fl-monthly-intro3d-1629-21787-gtq': {
    name: 'fl-monthly-intro3d-1629-21787-gtq',
    price: 217.87,
    periodPrice: 16.29,
    description: 'monthly',
    productId: '1 month - Q217.87',
    duration: '3 days - month',
    currency: 'GTQ',
    currencySymbol: 'Q',
  },
  'fl-monthly-intro3d-3265-21787-gtq': {
    name: 'fl-monthly-intro3d-3265-21787-gtq',
    price: 217.87,
    periodPrice: 32.65,
    description: 'monthly',
    productId: '1 month - Q217.87',
    duration: '3 days - month',
    currency: 'GTQ',
    currencySymbol: 'Q',
  },
  'fl-monthly-21787-gtq': {
    name: 'fl-monthly-21787-gtq',
    price: 217.87,
    periodPrice: 217.87,
    description: 'monthly',
    productId: '1 month - Q217.87',
    duration: '1 month',
    currency: 'GTQ',
    currencySymbol: 'Q',
  },
  'fl-3month-32683-gtq': {
    name: 'fl-3month-32683-gtq',
    price: 326.83,
    periodPrice: 326.83,
    description: 'quarterly',
    productId: '3 months - Q326.83',
    duration: '3 months',
    currency: 'GTQ',
    currencySymbol: 'Q',
  },

  // Paraguay PYG
  'fl-monthly-intro3d-1500000-20000000-pyg': {
    name: 'fl-monthly-intro3d-1500000-20000000-pyg',
    price: 200000,
    periodPrice: 15000,
    description: 'monthly',
    productId: '1 month - ₲200000',
    duration: '3 days - month',
    currency: 'PYG',
    currencySymbol: '₲',
  },
  'fl-monthly-intro3d-3900000-20000000-pyg': {
    name: 'fl-monthly-intro3d-3900000-20000000-pyg',
    price: 200000,
    periodPrice: 39000,
    description: 'monthly',
    productId: '1 month - ₲200000',
    duration: '3 days - month',
    currency: 'PYG',
    currencySymbol: '₲',
  },
  'fl-monthly-20000000-pyg': {
    name: 'fl-monthly-20000000-pyg',
    price: 200000,
    periodPrice: 200000,
    description: 'monthly',
    productId: '1 month - ₲200000',
    duration: '1 month',
    currency: 'PYG',
    currencySymbol: '₲',
  },
  'fl-3month-29000000-pyg': {
    name: 'fl-3month-29000000-pyg',
    price: 290000,
    periodPrice: 290000,
    description: 'quarterly',
    productId: '3 months - ₲290000',
    duration: '3 months',
    currency: 'PYG',
    currencySymbol: '₲',
  },

  // El Salvador USD
  'fl-monthly-intro3d-199-2399': {
    name: 'fl-monthly-intro3d-199-2399',
    price: 23.99,
    periodPrice: 1.99,
    description: 'monthly',
    productId: '1 month - $23.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-intro3d-399-2399': {
    name: 'fl-monthly-intro3d-399-2399',
    price: 23.99,
    periodPrice: 3.99,
    description: 'monthly',
    productId: '1 month - $23.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-monthly-2399': {
    name: 'fl-monthly-2399',
    price: 23.99,
    periodPrice: 23.99,
    description: 'monthly',
    productId: '1 month - $23.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fl-3month-3599': {
    name: 'fl-3month-3599',
    price: 35.99,
    periodPrice: 35.99,
    description: 'quarterly',
    productId: '3 months - $35.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },

  // Indian Rupee plans
  'fl-372332-inr-1-month-intro-27839-inr-3-day-sub': {
    name: 'fl-372332-inr-1-month-intro-27839-inr-3-day-sub',
    price: 3723.32,
    periodPrice: 278.39,
    description: 'monthly',
    productId: '1 month - ₹3723.32',
    duration: '3 days - month',
    currency: 'INR',
    currencySymbol: '₹',
  },
  'fl-372332-inr-1-month-intro-55771-inr-3-day-sub': {
    name: 'fl-372332-inr-1-month-intro-55771-inr-3-day-sub',
    price: 3723.32,
    periodPrice: 557.71,
    description: 'monthly',
    productId: '1 month - ₹3723.32',
    duration: '3 days - month',
    currency: 'INR',
    currencySymbol: '₹',
  },
  'fl-372332-inr-1-month-intro-186119-inr-1-month-sub': {
    name: 'fl-372332-inr-1-month-intro-186119-inr-1-month-sub',
    price: 3723.32,
    periodPrice: 3723.32,
    description: 'monthly',
    productId: '1 month - ₹3723.32',
    duration: '1 month',
    currency: 'INR',
    currencySymbol: '₹',
  },
  'fl-558544-inr-3-month-intro-372332-inr-3-month-sub': {
    name: 'fl-558544-inr-3-month-intro-372332-inr-3-month-sub',
    price: 5585.44,
    periodPrice: 5585.44,
    description: 'quarterly',
    productId: '3 months - ₹5585.44',
    duration: '3 months',
    currency: 'INR',
    currencySymbol: '₹',
  },

  // Peru PEN
  'fl-9099-pen-1-month-intro-699-pen-3-day-sub': {
    name: 'fl-9099-pen-1-month-intro-699-pen-3-day-sub',
    price: 90.99,
    periodPrice: 6.99,
    description: 'monthly',
    productId: '1 month - S/90.99',
    duration: '3 days - 1 month',
    currency: 'PEN',
    currencySymbol: 'S/',
  },
  'fl-9099-pen-1-month-intro-1399-pen-3-day-sub': {
    name: 'fl-9099-pen-1-month-intro-1399-pen-3-day-sub',
    price: 90.99,
    periodPrice: 13.99,
    description: 'monthly',
    productId: '1 month - S/90.99',
    duration: '3 days - 1 month',
    currency: 'PEN',
    currencySymbol: 'S/',
  },
  'fl-9099-pen-1-month-intro-4599-pen-1-month-sub': {
    name: 'fl-9099-pen-1-month-intro-4599-pen-1-month-sub',
    price: 90.99,
    periodPrice: 90.99,
    description: 'monthly',
    productId: '1 month - S/90.99',
    duration: '1 month',
    currency: 'PEN',
    currencySymbol: 'S/',
  },
  'fl-13999-pen-3-month-intro-9099-pen-3-month-sub': {
    name: 'fl-13999-pen-3-month-intro-9099-pen-3-month-sub',
    price: 139.99,
    periodPrice: 139.99,
    description: 'quarterly',
    productId: '3 months - S/139.99',
    duration: '3 months',
    currency: 'PEN',
    currencySymbol: 'S/',
  },

  // Saudi Arabia SAR
  'fl-11999-sar-1-month-intro-899-sar-3-day-sub': {
    name: 'fl-11999-sar-1-month-intro-899-sar-3-day-sub',
    price: 119.99,
    periodPrice: 8.99,
    description: 'monthly',
    productId: '1 month - SAR119.99',
    duration: '3 days - 1 month',
    currency: 'SAR',
    currencySymbol: 'SAR',
  },
  'fl-11999-sar-1-month-intro-1799-sar-3-day-sub': {
    name: 'fl-11999-sar-1-month-intro-1799-sar-3-day-sub',
    price: 119.99,
    periodPrice: 17.99,
    description: 'monthly',
    productId: '1 month - SAR119.99',
    duration: '3 days - 1 month',
    currency: 'SAR',
    currencySymbol: 'SAR',
  },
  'fl-11999-sar-1-month-intro-6099-sar-1-month-sub': {
    name: 'fl-11999-sar-1-month-intro-6099-sar-1-month-sub',
    price: 119.99,
    periodPrice: 119.99,
    description: 'monthly',
    productId: '1 month - SAR119.99',
    duration: '1 month',
    currency: 'SAR',
    currencySymbol: 'SAR',
  },
  'fl-17999-sar-3-month-intro-11999-sar-3-month-sub': {
    name: 'fl-17999-sar-3-month-intro-11999-sar-3-month-sub',
    price: 179.99,
    periodPrice: 179.99,
    description: 'quarterly',
    productId: '3 months - SAR179.99',
    duration: '3 months',
    currency: 'SAR',
    currencySymbol: 'SAR',
  },

  // Malaysia MYR
  'fl-11499-myr-1-month-intro-899-myr-3-day-sub': {
    name: 'fl-11499-myr-1-month-intro-899-myr-3-day-sub',
    price: 114.99,
    periodPrice: 8.99,
    description: 'monthly',
    productId: '1 month - RM114.99',
    duration: '3 days - 1 month',
    currency: 'MYR',
    currencySymbol: 'RM',
  },
  'fl-11499-myr-1-month-intro-1799-myr-3-day-sub': {
    name: 'fl-11499-myr-1-month-intro-1799-myr-3-day-sub',
    price: 114.99,
    periodPrice: 17.99,
    description: 'monthly',
    productId: '1 month - RM114.99',
    duration: '3 days - 1 month',
    currency: 'MYR',
    currencySymbol: 'RM',
  },
  'fl-11499-myr-1-month-intro-5799-myr-1-month-sub': {
    name: 'fl-11499-myr-1-month-intro-5799-myr-1-month-sub',
    price: 114.99,
    periodPrice: 114.99,
    description: 'monthly',
    productId: '1 month - RM114.99',
    duration: '1 month',
    currency: 'MYR',
    currencySymbol: 'RM',
  },
  'fl-17299-myr-3-month-intro-11499-myr-3-month-sub': {
    name: 'fl-17299-myr-3-month-intro-11499-myr-3-month-sub',
    price: 172.99,
    periodPrice: 172.99,
    description: 'quarterly',
    productId: '3 months - RM172.99',
    duration: '3 months',
    currency: 'MYR',
    currencySymbol: 'RM',
  },
  'fl-13499-myr-1-month-intro-1099-myr-3-day-sub': {
    name: 'fl-13499-myr-1-month-intro-1099-myr-3-day-sub',
    price: 134.99,
    periodPrice: 10.99,
    description: 'monthly',
    productId: '1 month - RM134.99',
    duration: '3 days - 1 month',
    currency: 'MYR',
    currencySymbol: 'RM',
  },
  'fl-13499-myr-1-month-intro-2199-myr-3-day-sub': {
    name: 'fl-13499-myr-1-month-intro-2199-myr-3-day-sub',
    price: 134.99,
    periodPrice: 21.99,
    description: 'monthly',
    productId: '1 month - RM134.99',
    duration: '3 days - 1 month',
    currency: 'MYR',
    currencySymbol: 'RM',
  },
  'fl-13499-myr-1-month-intro-6899-myr-1-month-sub': {
    name: 'fl-13499-myr-1-month-intro-6899-myr-1-month-sub',
    price: 134.99,
    periodPrice: 134.99,
    description: 'monthly',
    productId: '1 month - RM134.99',
    duration: '1 month',
    currency: 'MYR',
    currencySymbol: 'RM',
  },
  'fl-21099-myr-3-month-intro-13499-myr-3-month-sub': {
    name: 'fl-21099-myr-3-month-intro-13499-myr-3-month-sub',
    price: 210.99,
    periodPrice: 210.99,
    description: 'quarterly',
    productId: '3 months - RM210.99',
    duration: '3 months',
    currency: 'MYR',
    currencySymbol: 'RM',
  },

  // Portugal EUR
  'fl-3499-eur-1-month-intro-199-eur-3-day-sub': {
    name: 'fl-3499-eur-1-month-intro-199-eur-3-day-sub',
    price: 34.99,
    periodPrice: 1.99,
    description: 'monthly',
    productId: '1 month - €34.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3499-eur-1-month-intro-499-eur-3-day-sub': {
    name: 'fl-3499-eur-1-month-intro-499-eur-3-day-sub',
    price: 34.99,
    periodPrice: 4.99,
    description: 'monthly',
    productId: '1 month - €34.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3499-eur-1-month-intro-1799-eur-1-month-sub': {
    name: 'fl-3499-eur-1-month-intro-1799-eur-1-month-sub',
    price: 34.99,
    periodPrice: 34.99,
    description: 'monthly',
    productId: '1 month - €34.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-5299-eur-3-month-intro-3499-eur-3-month-sub': {
    name: 'fl-5299-eur-3-month-intro-3499-eur-3-month-sub',
    price: 52.99,
    periodPrice: 52.99,
    description: 'quarterly',
    productId: '3 months - €52.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },

  // Hungary HUF
  'fl-7999-huf-1-month-intro-599-huf-3-day-sub': {
    name: 'fl-7999-huf-1-month-intro-599-huf-3-day-sub',
    price: 7999,
    periodPrice: 599,
    description: 'monthly',
    productId: '1 month - Ft7999',
    duration: '3 days - 1 month',
    currency: 'HUF',
    currencySymbol: 'Ft',
  },
  'fl-7999-huf-1-month-intro-1199-huf-3-day-sub': {
    name: 'fl-7999-huf-1-month-intro-1199-huf-3-day-sub',
    price: 7999,
    periodPrice: 1199,
    description: 'monthly',
    productId: '1 month - Ft7999',
    duration: '3 days - 1 month',
    currency: 'HUF',
    currencySymbol: 'Ft',
  },
  'fl-7999-huf-1-month-intro-3999-huf-1-month-sub': {
    name: 'fl-7999-huf-1-month-intro-3999-huf-1-month-sub',
    price: 7999,
    periodPrice: 7999,
    description: 'monthly',
    productId: '1 month - Ft7999',
    duration: '1 month',
    currency: 'HUF',
    currencySymbol: 'Ft',
  },
  'fl-12000-huf-3-month-intro-7999-huf-3-month-sub': {
    name: 'fl-12000-huf-3-month-intro-7999-huf-3-month-sub',
    price: 12000,
    periodPrice: 12000,
    description: 'quarterly',
    productId: '3 months - Ft12000',
    duration: '3 months',
    currency: 'HUF',
    currencySymbol: 'Ft',
  },

  // Bolivia BOB
  'fl-17899-bob-1-month-intro-1399-bob-3-day-sub': {
    name: 'fl-17899-bob-1-month-intro-1399-bob-3-day-sub',
    price: 178.99,
    periodPrice: 13.99,
    description: 'monthly',
    productId: '1 month - Bs178.99',
    duration: '3 days - 1 month',
    currency: 'BOB',
    currencySymbol: 'Bs',
  },
  'fl-17899-bob-1-month-intro-2699-bob-3-day-sub': {
    name: 'fl-17899-bob-1-month-intro-2699-bob-3-day-sub',
    price: 178.99,
    periodPrice: 26.99,
    description: 'monthly',
    productId: '1 month - Bs178.99',
    duration: '3 days - 1 month',
    currency: 'BOB',
    currencySymbol: 'Bs',
  },
  'fl-17899-bob-1-month-intro-8999-bob-1-month-sub': {
    name: 'fl-17899-bob-1-month-intro-8999-bob-1-month-sub',
    price: 178.99,
    periodPrice: 178.99,
    description: 'monthly',
    productId: '1 month - Bs178.99',
    duration: '1 month',
    currency: 'BOB',
    currencySymbol: 'Bs',
  },
  'fl-26899-bob-3-month-intro-17899-bob-3-month-sub': {
    name: 'fl-26899-bob-3-month-intro-17899-bob-3-month-sub',
    price: 268.99,
    periodPrice: 268.99,
    description: 'quarterly',
    productId: '3 months - Bs268.99',
    duration: '3 months',
    currency: 'BOB',
    currencySymbol: 'Bs',
  },

  // Romania RON
  'fl-13599-ron-1-month-intro-1099-ron-3-day-sub': {
    name: 'fl-13599-ron-1-month-intro-1099-ron-3-day-sub',
    price: 135.99,
    periodPrice: 10.99,
    description: 'monthly',
    productId: '1 month - RON 135.99',
    duration: '3 days - 1 month',
    currency: 'RON',
    currencySymbol: 'RON',
  },
  'fl-13599-ron-1-month-intro-2099-ron-3-day-sub': {
    name: 'fl-13599-ron-1-month-intro-2099-ron-3-day-sub',
    price: 135.99,
    periodPrice: 20.99,
    description: 'monthly',
    productId: '1 month - RON 135.99',
    duration: '3 days - 1 month',
    currency: 'RON',
    currencySymbol: 'RON',
  },
  'fl-13599-ron-1-month-intro-6799-ron-1-month-sub': {
    name: 'fl-13599-ron-1-month-intro-6799-ron-1-month-sub',
    price: 135.99,
    periodPrice: 135.99,
    description: 'monthly',
    productId: '1 month - RON 135.99',
    duration: '1 month',
    currency: 'RON',
    currencySymbol: 'RON',
  },
  'fl-20199-ron-3-month-intro-13599-ron-3-month-sub': {
    name: 'fl-20199-ron-3-month-intro-13599-ron-3-month-sub',
    price: 201.99,
    periodPrice: 201.99,
    description: 'quarterly',
    productId: '3 months - RON 201.99',
    duration: '3 months',
    currency: 'RON',
    currencySymbol: 'RON',
  },

  // Guatemala GTQ (new pricing)
  'fl-23099-gtq-1-month-intro-1899-gtq-3-day-sub': {
    name: 'fl-23099-gtq-1-month-intro-1899-gtq-3-day-sub',
    price: 230.99,
    periodPrice: 18.99,
    description: 'monthly',
    productId: '1 month - Q230.99',
    duration: '3 days - 1 month',
    currency: 'GTQ',
    currencySymbol: 'Q',
  },
  'fl-23099-gtq-1-month-intro-3799-gtq-3-day-sub': {
    name: 'fl-23099-gtq-1-month-intro-3799-gtq-3-day-sub',
    price: 230.99,
    periodPrice: 37.99,
    description: 'monthly',
    productId: '1 month - Q230.99',
    duration: '3 days - 1 month',
    currency: 'GTQ',
    currencySymbol: 'Q',
  },
  'fl-23099-gtq-1-month-intro-11599-gtq-1-month-sub': {
    name: 'fl-23099-gtq-1-month-intro-11599-gtq-1-month-sub',
    price: 230.99,
    periodPrice: 230.99,
    description: 'monthly',
    productId: '1 month - Q230.99',
    duration: '1 month',
    currency: 'GTQ',
    currencySymbol: 'Q',
  },
  'fl-34599-gtq-3-month-intro-23099-gtq-3-month-sub': {
    name: 'fl-34599-gtq-3-month-intro-23099-gtq-3-month-sub',
    price: 345.99,
    periodPrice: 345.99,
    description: 'quarterly',
    productId: '3 months - Q345.99',
    duration: '3 months',
    currency: 'GTQ',
    currencySymbol: 'Q',
  },

  // Poland PLN
  'fl-11299-pln-1-month-intro-1899-pln-3-day-sub': {
    name: 'fl-11299-pln-1-month-intro-1899-pln-3-day-sub',
    price: 112.99,
    periodPrice: 18.99,
    description: 'monthly',
    productId: '1 month - zł112.99',
    duration: '3 days - 1 month',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fl-11299-pln-1-month-intro-3799-pln-3-day-sub': {
    name: 'fl-11299-pln-1-month-intro-3799-pln-3-day-sub',
    price: 112.99,
    periodPrice: 37.99,
    description: 'monthly',
    productId: '1 month - zł112.99',
    duration: '3 days - 1 month',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fl-11299-pln-1-month-intro-5699-pln-1-month-sub': {
    name: 'fl-11299-pln-1-month-intro-5699-pln-1-month-sub',
    price: 112.99,
    periodPrice: 112.99,
    description: 'monthly',
    productId: '1 month - zł112.99',
    duration: '1 month',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fl-16699-pln-3-month-intro-11299-pln-3-month-sub': {
    name: 'fl-16699-pln-3-month-intro-11299-pln-3-month-sub',
    price: 166.99,
    periodPrice: 166.99,
    description: 'quarterly',
    productId: '3 months - zł166.99',
    duration: '3 months',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fl-14728-pln-1-month-intro-1101-pln-3-day-sub': {
    name: 'fl-14728-pln-1-month-intro-1101-pln-3-day-sub',
    price: 147.28,
    periodPrice: 11.01,
    description: 'monthly',
    productId: '1 month - zł147.28',
    duration: '3 days - 1 month',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fl-14728-pln-1-month-intro-2206-pln-3-day-sub': {
    name: 'fl-14728-pln-1-month-intro-2206-pln-3-day-sub',
    price: 147.28,
    periodPrice: 22.06,
    description: 'monthly',
    productId: '1 month - zł147.28',
    duration: '3 days - 1 month',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fl-14728-pln-1-month-intro-7362-pln-1-month-sub': {
    name: 'fl-14728-pln-1-month-intro-7362-pln-1-month-sub',
    price: 147.28,
    periodPrice: 147.28,
    description: 'monthly',
    productId: '1 month - zł147.28',
    duration: '1 month',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fl-22094-pln-3-month-intro-14728-pln-3-month-sub': {
    name: 'fl-22094-pln-3-month-intro-14728-pln-3-month-sub',
    price: 220.94,
    periodPrice: 220.94,
    description: 'quarterly',
    productId: '3 months - zł220.94',
    duration: '3 months',
    currency: 'PLN',
    currencySymbol: 'zł',
  },

  // Japan JPY
  'fl-4419-jpy-1-month-intro-315-jpy-3-day-sub': {
    name: 'fl-4419-jpy-1-month-intro-315-jpy-3-day-sub',
    price: 4419,
    periodPrice: 315,
    description: 'monthly',
    productId: '1 month - ¥4419',
    duration: '3 days - 1 month',
    currency: 'JPY',
    currencySymbol: '¥',
  },
  'fl-4419-jpy-1-month-intro-629-jpy-3-day-sub': {
    name: 'fl-4419-jpy-1-month-intro-629-jpy-3-day-sub',
    price: 4419,
    periodPrice: 629,
    description: 'monthly',
    productId: '1 month - ¥4419',
    duration: '3 days - 1 month',
    currency: 'JPY',
    currencySymbol: '¥',
  },
  'fl-4419-jpy-1-month-intro-2199-jpy-1-month-sub': {
    name: 'fl-4419-jpy-1-month-intro-2199-jpy-1-month-sub',
    price: 4419,
    periodPrice: 4419,
    description: 'monthly',
    productId: '1 month - ¥4419',
    duration: '1 month',
    currency: 'JPY',
    currencySymbol: '¥',
  },
  'fl-6369-jpy-3-month-intro-4419-jpy-3-month-sub': {
    name: 'fl-6369-jpy-3-month-intro-4419-jpy-3-month-sub',
    price: 6369,
    periodPrice: 6369,
    description: 'quarterly',
    productId: '3 months - ¥6369',
    duration: '3 months',
    currency: 'JPY',
    currencySymbol: '¥',
  },

  // Dominican Republic DOP
  'fl-212999-dop-1-month-intro-15399-dop-3-day-sub': {
    name: 'fl-212999-dop-1-month-intro-15399-dop-3-day-sub',
    price: 2129.99,
    periodPrice: 153.99,
    description: 'monthly',
    productId: '1 month - RD$2129.99',
    duration: '3 days - 1 month',
    currency: 'DOP',
    currencySymbol: 'RD$',
  },
  'fl-212999-dop-1-month-intro-30799-dop-3-day-sub': {
    name: 'fl-212999-dop-1-month-intro-30799-dop-3-day-sub',
    price: 2129.99,
    periodPrice: 307.99,
    description: 'monthly',
    productId: '1 month - RD$2129.99',
    duration: '3 days - 1 month',
    currency: 'DOP',
    currencySymbol: 'RD$',
  },
  'fl-212999-dop-1-month-intro-106499-dop-1-month-sub': {
    name: 'fl-212999-dop-1-month-intro-106499-dop-1-month-sub',
    price: 2129.99,
    periodPrice: 2129.99,
    description: 'monthly',
    productId: '1 month - RD$2129.99',
    duration: '1 month',
    currency: 'DOP',
    currencySymbol: 'RD$',
  },
  'fl-319299-dop-3-month-intro-212999-dop-3-month-sub': {
    name: 'fl-319299-dop-3-month-intro-212999-dop-3-month-sub',
    price: 3192.99,
    periodPrice: 3192.99,
    description: 'quarterly',
    productId: '3 months - RD$3192.99',
    duration: '3 months',
    currency: 'DOP',
    currencySymbol: 'RD$',
  },

  // South Africa ZAR
  'fl-32999-zar-1-month-intro-2299-zar-3-day-sub': {
    name: 'fl-32999-zar-1-month-intro-2299-zar-3-day-sub',
    price: 329.99,
    periodPrice: 22.99,
    description: 'monthly',
    productId: '1 month - R329.99',
    duration: '3 days - 1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-32999-zar-1-month-intro-4599-zar-3-day-sub': {
    name: 'fl-32999-zar-1-month-intro-4599-zar-3-day-sub',
    price: 329.99,
    periodPrice: 45.99,
    description: 'monthly',
    productId: '1 month - R329.99',
    duration: '3 days - 1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-32999-zar-1-month-intro-18099-zar-1-month-sub': {
    name: 'fl-32999-zar-1-month-intro-18099-zar-1-month-sub',
    price: 329.99,
    periodPrice: 329.99,
    description: 'monthly',
    productId: '1 month - R329.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fl-49399-zar-3-month-intro-32999-zar-3-month-sub': {
    name: 'fl-49399-zar-3-month-intro-32999-zar-3-month-sub',
    price: 493.99,
    periodPrice: 493.99,
    description: 'quarterly',
    productId: '3 months - R493.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },

  // Brazil BRL (new pricing)
  'fl-11399-brl-1-month-intro-599-brl-3-day-sub': {
    name: 'fl-11399-brl-1-month-intro-599-brl-3-day-sub',
    price: 113.99,
    periodPrice: 5.99,
    description: 'monthly',
    productId: '1 month - R$113.99',
    duration: '3 days - 1 month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-17154-brl-1-month-intro-566-brl-1-day-sub': {
    name: 'fl-17154-brl-1-month-intro-566-brl-1-day-sub',
    price: 171.54,
    periodPrice: 5.66,
    description: 'monthly',
    productId: '1 month - R$171.54',
    duration: '1 day - 1 month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-11199-brl-1-month-intro-799-brl-3-day-sub': {
    name: 'fl-11199-brl-1-month-intro-799-brl-3-day-sub',
    price: 111.99,
    periodPrice: 7.99,
    description: 'monthly',
    productId: '1 month - R$111.99',
    duration: '3 days - 1 month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-11199-brl-1-month-intro-1099-brl-3-day-sub': {
    name: 'fl-11199-brl-1-month-intro-1099-brl-3-day-sub',
    price: 111.99,
    periodPrice: 10.99,
    description: 'monthly',
    productId: '1 month - R$111.99',
    duration: '3 days - 1 month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-11199-brl-1-month-intro-5599-brl-1-month-sub': {
    name: 'fl-11199-brl-1-month-intro-5599-brl-1-month-sub',
    price: 111.99,
    periodPrice: 111.99,
    description: 'monthly',
    productId: '1 month - R$111.99',
    duration: '1 month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fl-21399-brl-3-month-intro-11199-brl-3-month-sub': {
    name: 'fl-21399-brl-3-month-intro-11199-brl-3-month-sub',
    price: 213.99,
    periodPrice: 213.99,
    description: 'quarterly',
    productId: '3 months - R$213.99',
    duration: '3 months',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
};
